import React,{useState,useEffect,useCallback} from 'react'
import MallCard from './MallCard';
import './MallList.css';
import axios from 'axios';
import { Pagination } from 'antd';
import { useParams } from 'react-router-dom';

export default function MallList() {
  const params = useParams();

  const [mallList,setMallList] = useState([])
  const [mallCnt,setMallCnt] = useState(0)
  const [pageIndex,setPageIndex] = useState(1)

  //function getMallList(pageIndex,pageSize) {    
  const getMallList = useCallback(async (pageIndex,pageSize) => {  
    try {
          let reqUrl = "https://api.360ep.cn/api/mall?pagesize=" + pageSize + "&page=" + pageIndex;
          if (params.appid && params.appid !== '0') {
              reqUrl += "&appid=" + params.appid;              
          }

          if (params.orderby && params.orderby !== 'default') {
            reqUrl += "&orderby=" + params.orderby;
          }

          if (params.ordertype) {
            reqUrl += "&ordertype=" + params.ordertype;
          }
                    
          axios.get(reqUrl).then(res=>{ 
            let mallList = [];       
            
            if(res.data.data && res.data.total>0){
              res.data.data.forEach(item => {
                  mallList.push({
                      itemid: item.Itemid,
                      imageUrl: item.Thumb,
                      price: item.Price,
                      name: item.Title,
                      companyName: item.Company,
                      location: item.Areaname,                                         
                  });
              });
            }
            
            setMallList(mallList);
            setMallCnt(res.data.total)       
         })
          
      } catch (error) {
          if (axios.isCancel(error)) {
              console.log("Request canceled", error.message);
          } else {
              console.log("Error", error.message);
          }
      }
  },[params]);

  useEffect(() => {           
    getMallList(1,20);   
  }, [params,getMallList]);

  function pageChoose(page, pageSize) {
    setPageIndex(page)
    getMallList(page,pageSize)
  }

  return (
    <div>
        <div className='mall-list'>            
        {mallList.map((cardData) => (                  
            <MallCard {...cardData} key={cardData.itemid}/>            
        ))}     
        </div>
        { (mallCnt>0 && <div className='mall-page'><Pagination current={pageIndex} total={mallCnt} pageSize={20} showSizeChanger={false} onChange={pageChoose} /></div>)
        }
        { (mallCnt===0 && <div className='mall-page'>暂无数据</div>)}        
    </div>
  );
};
